(function () {
  function init() {
    document.querySelectorAll('[data-thyred-hero]').forEach(function (hero) {
      var intensity = parseFloat(hero.getAttribute('data-glow-intensity') || '100');
      hero.style.setProperty('--glow-scale', (intensity / 100) * 1.4 + 0.4);
      hero.style.setProperty('--glow-op', intensity / 100);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
